import { type Position } from 'services'
import { type HttpResponse, http, handleHttpRequest } from 'interfaces'

const createIdAndDisplayOrderMap = (positions: Position[]): Record<number, number> => {
  const idAndDisplayOrderMap: Record<number, number> = {}

  positions.forEach((position, index) => {
    idAndDisplayOrderMap[position.id] = index + 1
  })
  return idAndDisplayOrderMap
}

export async function patchPersonPositionsDisplayOrder (personId: number, positions: Position[], positionIdSelected: number): Promise<HttpResponse<Position[]>> {
  const displayIdsAndDisplayOrders = createIdAndDisplayOrderMap(positions)
  return await handleHttpRequest(http.patch(`/api/v1/people/${personId}/positions/`, {
    idAndDisplayOrderMap: displayIdsAndDisplayOrders,
    positionIdSelected
  }))
}
